// extracted by mini-css-extract-plugin
export default {"newsletter":"page2_newsletter__XEhHi","mobileAndText":"page2_mobileAndText__5x0GY"};